import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {TopicSchema} from './topic'
import {ResourceSummarySchema} from './resource-summary'

/**
 * Schema for filters grouped by concept scheme.
 * Keys are scheme IDs (e.g., 'topic', 'region', 'type'),
 * values are arrays of concepts belonging to that scheme.
 */
export const FiltersSchema = z.record(z.string(), z.array(TopicSchema))

export type Filters = z.infer<typeof FiltersSchema>

/**
 * Payload schema for dynamic index pages with taxonomy-based filtering.
 * Used for index pages where resources are fetched dynamically
 * based on selected concepts from the taxonomy service.
 */
export const DynamicIndexPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    filters: FiltersSchema,
    resources: z.array(ResourceSummarySchema).optional(),
    additionalProps: z
      .object({
        selectedFilters: z.record(z.string(), z.array(z.string())).optional(),
        totalPages: z.number().optional(),
        sortOptions: z
          .array(
            z.object({
              label: z.string(),
              value: z.string(),
            }),
          )
          .optional(),
        currentSort: z.string().optional(),
      })
      .optional(),
  }),
)

export type DynamicIndexPayload = z.infer<typeof DynamicIndexPayloadSchema>

export function toDynamicIndexPayload(payload: unknown): DynamicIndexPayload {
  return DynamicIndexPayloadSchema.parse(payload)
}

export function isDynamicIndexPayload(payload: unknown): payload is DynamicIndexPayload {
  return DynamicIndexPayloadSchema.safeParse(payload).success
}
